export default "__VITE_ASSET__7480efe0__"